import { CALL_API } from '../constants/apiConstants';
import authActions from '../actions/authActions';
import apiUtils from '../utils/apiUtils'
function callApi(action, next, dispatch, getState, hasLocate) {
   const {
      endpoint,
      types,
      method,
      body,
      params,
      acceptHeader,
   } = action[CALL_API];
   const language = hasLocate ? 'es-mx' : '';
   const { auth: { token, key }, accountWrapper: { code } } = getState();
   // account: { code, channel } 
   return new Promise((resolve, reject) => {
      apiUtils.call({
         endpoint,
         types,
         method,
         body,
         params,
         token,
         language,
         account: code,
         // channel,
         acceptHeader,
         key
      })
         .then(response => {
            resolve(response);
         })
         .catch(error => {
            if (error.response && error.response.status === 401) {
               dispatch(authActions.logout());
               Promise.resolve();
            } else {
               reject(error);
            }
         });
   });
}

function jwt({ dispatch, getState }) {

   return (next) => (action) => {
      const callAPI = action[CALL_API];
      if (typeof callAPI === 'undefined') {
         return next(action);
      }
      return callApi(action, next, dispatch, getState, true);
   };
}

export default { jwt };
